import { useEffect, useState, useRef } from "react"

export function useFirstTimeInView() {
  const [hasBeenInView, setHasBeenInView] = useState(false)
  const ref = useRef(null) // Use this ref on your target element

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasBeenInView) {
            setHasBeenInView(true)
            observer.disconnect()
          }
        })
      },
      { threshold: 0.05 }
    )

    const currentElement = ref.current
    if (currentElement) {
      observer.observe(currentElement)
    }

    return () => observer.disconnect()
  }, [hasBeenInView])

  return [hasBeenInView, ref]
}
